// extracted by mini-css-extract-plugin
export default {"feed":"Feed_feed__UfzwF","feedcontent":"Feed_feedcontent__7S5z5"};